/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function FacebookLogo(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M128,24a104.0018,104.0018,0,0,0-8,207.69531V152.00094H96a8,8,0,0,1,0-16h24v-24a32.03667,32.03667,0,0,1,32-32h16a8,8,0,0,1,0,16H152a16.01833,16.01833,0,0,0-16,16v24h24a8,8,0,0,1,0,16H136v79.69434A104.0018,104.0018,0,0,0,128,24Z" />
    </Svg>
  );
}

export default FacebookLogo;
